import { NgModule } from '@angular/core';
import { AmdButtonDirective } from './button.directive';
export class AmdButtonModule {
}
AmdButtonModule.decorators = [
    { type: NgModule, args: [{
                declarations: [AmdButtonDirective],
                exports: [AmdButtonDirective]
            },] },
];
/**
 * @nocollapse
 */
AmdButtonModule.ctorParameters = () => [];
function AmdButtonModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdButtonModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdButtonModule.ctorParameters;
}
//# sourceMappingURL=button.module.js.map
//# sourceMappingURL=button.module.js.map
